// jquery sileToggle in vanilla js
import './slideToggle.min';

/**
 *
 */
export default function () {

	// breakpoint conditions
	//
	let viewportWidth;
	/**
	 *
	 */
	const setViewportWidth = function () {

		viewportWidth = window.innerWidth || document.documentElement.clientWidth;

	}
	setViewportWidth();

	if ( document.querySelector( '.js-accordionList_item' ) ) {

		document.querySelector( '.js-accordionList_item' ).classList.add( 'active' );
		document.querySelector( '.js-accordionList_collapse' ).slideDown();
		document.querySelector( '.js-accordionList_collapseMobile' ).slideDown();

		document.addEventListener( 'click', function ( event ) {

			if ( !event.target.classList.contains( 'js-accordionList_toggle' ) ) {

				return;

			}

			const item = document.querySelector( event.target.hash );
			const collapse = item.querySelector( '.js-accordionList_collapse' );
			const collapseMobile = item.querySelector( '.js-accordionList_collapseMobile' );

			event.preventDefault();

			if ( item.classList.contains( 'active' ) ) {

				return;

			}

			let accordions = document.querySelectorAll( '.js-accordionList_item.active' );
			for ( let i = 0; i < accordions.length; i++ ) {

				accordions[i].classList.remove( 'active' );

				if ( viewportWidth >= 1024 ) {

					accordions[i].querySelector( '.js-accordionList_collapse' ).slideUp();

				} else {

					accordions[i].querySelector( '.js-accordionList_collapseMobile' ).slideUp();

				}

			}

			item.classList.toggle( 'active' );

			if ( viewportWidth >= 1024 ) {

				collapse.slideToggle();

			} else {

				collapseMobile.slideToggle();

			}

		} );

	}

	// on resize recalculate vw and run relevant functions
	//
	window.addEventListener( 'resize', function () {

		setViewportWidth();

	}, false );

}
